export const ReactQuery = { MaxRetries: 3 };
